import { PreIcon } from '@advanza/ui'
import clsx from 'clsx'
import { HEALTH_SCORE_WIDGET_ID, SEGMENT_BADGE_CLASSES } from './healthScoreConstants'
import { useHealthScore } from './useHealthScore'

interface HealthScoreHeaderBadgeProps {
    providerId: number
}

const HealthScoreHeaderBadge = ({ providerId }: HealthScoreHeaderBadgeProps) => {
    const { data, isLoading } = useHealthScore(providerId)

    if (isLoading || !data) {
        return null
    }

    const handleClick = () =>
        document
            .getElementById(HEALTH_SCORE_WIDGET_ID)
            ?.scrollIntoView({ behavior: 'smooth', block: 'start' })

    return (
        <button
            type="button"
            onClick={handleClick}
            title="Jump to health score"
            className={clsx(
                'inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-md font-medium hover:brightness-95 transition',
                SEGMENT_BADGE_CLASSES[data.segment],
            )}>
            <PreIcon icon="vital_signs" classNameIcon={SEGMENT_BADGE_CLASSES[data.segment]}>
                {data.health_score.toFixed(1)}
            </PreIcon>
        </button>
    )
}

export default HealthScoreHeaderBadge
